"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StandaloneTokenProvider = void 0;
var _react = require("react");
var _TokenService = require("../TokenService");
var _constants = require("../constants");
var _internals = require("../internals");
var _logger = require("../logger");
var _tokenContext = require("./tokenContext");
var _jsxRuntime = require("react/jsx-runtime");
var logger = _logger.mainLogger.createChild('StandaloneTokenProvider');
// TODO: true customerId, when logged in, is not always known at the start of application that uses this provider (case of SSG)
// This opts user out of their true user token since this provider does not try to fetch it and just fetches/returns public token when unathorized customerId is provided
/** @deprecated Use `UniversalTokenProvider` instead */ var StandaloneTokenProvider = function(param) {
    var children = param.children, token = param.token, customerId = param.customerId;
    var _ref = _sliced_to_array((0, _react.useState)(token ? (0, _internals.cleanToken)(token) : undefined), 2), clientToken = _ref[0], setClientToken = _ref[1];
    var _ref1 = _sliced_to_array((0, _react.useState)(true), 2), isAnonymous = _ref1[0], setIsAnonymous = _ref1[1];
    var _ref2 = _sliced_to_array((0, _react.useState)(false), 2), isUserVerified = _ref2[0], setIsUserVerified = _ref2[1];
    (0, _react.useEffect)(function() {
        if (token) {
            setClientToken(token);
        } else {
            var fetchToken = /*#__PURE__*/ function() {
                var _ref = _async_to_generator(function() {
                    var fetchedToken;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _TokenService.TokenService.getInstance().getAuthorizationToken(customerId)
                                ];
                            case 1:
                                fetchedToken = _state.sent();
                                setClientToken(fetchedToken);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function fetchToken() {
                    return _ref.apply(this, arguments);
                };
            }();
            fetchToken().catch(function(error) {
                logger.error(new Error('Fetching token failed', {
                    cause: error
                }));
                setClientToken('');
            }).finally(function() {
                return setIsUserVerified(true);
            });
        }
    }, [
        customerId,
        token
    ]);
    (0, _react.useEffect)(function() {
        if (customerId === _constants.NOT_LOGGED_IN_USER_ID) {
            setIsAnonymous(true);
        } else {
            setIsAnonymous(false);
        }
    }, [
        customerId
    ]);
    (0, _react.useEffect)(function() {
        var remainder = (0, _internals.getRemainingSeconds)(clientToken !== null && clientToken !== void 0 ? clientToken : '');
        // in the future, we will want to refresh the token here when the token is about to expire; for now, we are just writing a warning to the console.
        var timer = setTimeout(function() {
            logger.info('Your access token has expired. Please reload the page to acquire a new one.');
        }, remainder * 1000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        clientToken
    ]);
    var tokenValue = (0, _internals.cleanToken)(clientToken !== null && clientToken !== void 0 ? clientToken : '');
    var contextValue = (0, _react.useMemo)(function() {
        return {
            token: tokenValue,
            customerId: customerId,
            formattedToken: tokenValue ? "Bearer ".concat(tokenValue) : '',
            isAnonymousUser: isAnonymous,
            isUserVerified: isUserVerified
        };
    }, [
        customerId,
        isAnonymous,
        isUserVerified,
        tokenValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_tokenContext.tokenContext.Provider, {
        value: contextValue,
        children: children
    });
};
exports.StandaloneTokenProvider = StandaloneTokenProvider; //# sourceMappingURL=StandaloneTokenProvider.js.map
